import * as React from 'react';
import { ViewMain } from "./Components/View";
import { Controller } from "./Infraestructure/Controller";
import { ModalPermissNotification } from './Components/Modal/ModalPermissNotification';


const ManagerEntity = () => {
    const controller = Controller();

    React.useEffect(() => {
        controller.init();
        return () => { }
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <ViewMain
                menu={controller.menu}
                onClickAyuda={controller.onClickAyuda}
                onClickReport={controller.onClickReport}
                onClickMenu={controller.onClickMenu}
            />
            <ModalPermissNotification
                closeModal={controller.closeModal}
                modalPermiss={controller.modalPermiss}
                onChangeOptionsPermiss={controller.onChangeOptionsPermiss}
                onSubmit={controller.onSubmit}
            />
        </>
    );
};

export default ManagerEntity;